class FAQSidebar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.appendLinks();
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.addEventListener('click', (event) => {
      if (event.target.tagName === 'A') {
        this.handleLinkClick(event);
      }
    });
  }

  getSections() {
    return [...document.querySelectorAll(".accordion-container")].reduce(
      (sections, section) => {

        sections.push({
          id: section.id,
          title: section.dataset.title,
        });
        
        return sections;
      },
      []
    );
  }

  onScroll() {
    const sections = this.getSections();
    let currentSectionId = '';
    const offset = 180;
    sections.forEach((section) => {
      const element = document.getElementById(section.id);
      const rect = element.getBoundingClientRect();
      console.log(rect.top, rect.bottom);
      if (rect.top <= offset && rect.bottom >= offset) {
        currentSectionId = section.id;
      }
    });

    this.updateActiveLink(currentSectionId);
  }

  updateActiveLink(currentSectionId) {
    const links = this.querySelectorAll('a');
    links.forEach((link) => {
      if (link.getAttribute('href').substring(1) === currentSectionId) {
        link.classList.add('is-current');
      } else {
        link.classList.remove('is-current');
      }
    });
  }

  renderLinks() {
    return this.getSections().map((section) => {
      return `
        <li>
          <a href="#${section.id}">${section.title}</a>
        </li>
      `;
    }).join('');
  }

  appendLinks() {
    this.innerHTML = `
      <div class="faq-sidebar">
        <ul>
          ${this.renderLinks()}
        </ul>
      </div>
    `;
  }

  handleLinkClick(event) {
    event.preventDefault();
    const targetId = event.target.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      event.target.classList.add('is-current');
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

customElements.define("faq-sidebar", FAQSidebar);